// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__1T7Zn","detailsBorder":"styles_detailsBorder__1yX5L"};